import { NEXT_URLS } from "../../utils/routes/routes.constants";
import { makeOption } from "@/shared/utils/select";

export const Tab = {
  EGW: "egw",
  BIBLE: "bible",
};

export const IdsTabs = Object.values(Tab);

export const Tabs = [
  makeOption(Tab.EGW, "egw", {url: NEXT_URLS.bibliographyEgw }),
  makeOption(Tab.BIBLE, "bible", {url: NEXT_URLS.bibliographyBible }),
];

export const TabColumns = [
  {
    className: "abbreviation-code",
    filedName: "abbreviations",
    title: "abbreviation",
  },
  {
    className: "abbreviation-book-name",
    filedName: "title",
    title: "bookOrPeriodicalTitle",
  },
  {
    className: "abbreviation-publication",
    filedName: "pub_year",
    title: "publication",
  },
];
